import customAxios from "../index";
import qs from "qs";

export interface Partner {
  id: number;
  businessName: string;
  email: string;
}

export interface SupportTicket {
  id: number;
  ticketId?: string;
  ticket_id?: string;
  name: string;
  providerName?: string;
  contactEmail?: string;
  contact_email?: string;
  contactNumber?: string;
  contact_number?: string;
  subject: string;
  detailedDescription?: string;
  description?: string;
  status: string;
  createdAt?: string;
  closed_date?: string;
  created_at?: string;
  dateRaised?: string;
  dateClosed?: string;
  attachments?: string[];
  attachmentUrl?: string;
  lastUpdatedBy?: string;
  lastUpdatedAt?: string;
  last_updated_by?: string;
  last_updated_at?: string;
  partner?: Partner;
}

export interface SupportTicketsResponse {
  success: boolean;
  data: {
    message: string;
    data: {
      totalRecords: number;
      supportRequests: SupportTicket[];
    };
  };
}

export interface SupportTicketDetailsResponse {
  success: boolean;
  data: {
    message: string;
    data: {
      totalRecords: number;
      supportRequests: SupportTicket[];
    };
  };
}

export interface UpdateTicketStatusPayload {
  status: "Open" | "InProgress" | "Closed" | "ReOpen";
  comments?: string;
}

export const getSupportTickets = (params?: {
  page?: number;
  pageSize?: number;
  limit?: number;
  offset?: number;
  search?: string;
  searchText?: string;
  status?: string | string[];
  closedTab?: boolean;
  fromDate?: string;
  toDate?: string;
  partners?: string | string[];
  partner?: string | string[];
  dateRaisedStart?: string;
  dateRaisedEnd?: string;
  dateClosedStart?: string;
  dateClosedEnd?: string;
}) => {
  const queryParams: any = {};

  if (params?.limit) queryParams.limit = params.limit;
  if (params?.offset !== undefined) queryParams.offset = params.offset;
  if (params?.search) queryParams.searchText = params.search;
  if (params?.searchText) queryParams.searchText = params.searchText;
  if (params?.closedTab) queryParams.closedTab = params.closedTab;
  if (params?.status) queryParams.status = params.status;
  if (params?.partners) queryParams.partner = params.partners;
  if (params?.partner) queryParams.partner = params.partner;
  if (params?.dateRaisedStart) queryParams.dateRaisedStart = params.dateRaisedStart;
  if (params?.dateRaisedEnd) queryParams.dateRaisedEnd = params.dateRaisedEnd;
  if (params?.dateClosedStart) queryParams.dateClosedStart = params.dateClosedStart;
  if (params?.dateClosedEnd) queryParams.dateClosedEnd = params.dateClosedEnd;

  return customAxios({
    method: "GET",
    url: "/admin/communication-support",
    params: queryParams,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  });
};

export const getSupportTicketDetails = (ticketId: string) => {
  let id = ticketId;

  const numericMatch = ticketId.match(/(\d+)$/);
  if (numericMatch) {
    id = numericMatch[1];
  }

  return customAxios({
    method: "GET",
    url: `/admin/communication-support/${id}`,
  });
};

export const updateTicketStatus = (
  ticketId: number,
  data: UpdateTicketStatusPayload
) => {
  return customAxios({
    method: "PUT",
    url: `/admin/communication-support/${ticketId}`,
    data,
  });
};

